import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ManagerService} from '../../manager/manager.service';
import {MatTableDataSource} from '@angular/material/table';
import {ManagerFilter} from '../../manager/managerFilter';
import {MatSort} from '@angular/material/sort';

@Component({
    selector: 'app-employee-details-pop-up',
    templateUrl: './employee-details-pop-up.component.html',
    styleUrls: ['./employee-details-pop-up.component.scss']
})
export class EmployeeDetailsPopUpComponent implements OnInit {

    public dataSourceVacation: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceWork: MatTableDataSource<any> = new MatTableDataSource<any>([]);

    public filterEntity: ManagerFilter;
    public getDisplayValueVacation = new Map<string, string>();
    public getDisplayValueWork = new Map<string, string>();

    public fieldNames = ['dateCreated', 'halfDay', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'requestStatus', 'absenceType', 'absenceReason'];
    public displayNames = ['Date Created', 'Half day', 'Start Date', 'End Date',
        'Total Absence', 'Request Status', 'Absence Type', 'Absence Reason'];

    public fieldNamesWork = ['country', 'dateCreated', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'numberOfWorkAbroadDays', 'requestStatus'];
    public displayNamesWork = ['Country', 'Date Created', 'Start Date', 'End Date',
        'Annual Leave Length', 'Work Abroad Length', 'Approval Status'];

    @ViewChild('vacationSort', {read: MatSort, static: false})
    set vacationSort(value: MatSort) {
        if (this.dataSourceVacation) {
            this.dataSourceVacation.sort = value;
        }
    };

    @ViewChild('workAbroadSort', {read: MatSort, static: false})
    set workAbroadSort(value: MatSort) {
        if (this.dataSourceWork) {
            this.dataSourceWork.sort = value;
        }
    };

    constructor(public dialogRef: MatDialogRef<[]>,
                private readonly managerService: ManagerService,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
        this.filterEntity = new ManagerFilter();
    }

    ngOnInit(): void {
        this.filterEntity.year = String(new Date().getFullYear());
        this.selectedData[0].pendingVacation.forEach((data: any) => {
            if (data.gmin == this.selectedData[1].gmin) {
                this.dataSourceVacation.data.push(data);
            }
        });
        this.selectedData[0].pendingWork.forEach((value: any) => {
            if (value.gmin == this.selectedData[1].gmin) {
                this.dataSourceWork.data.push(value);
            }
        });
        this.calculateCardValues(String(new Date().getFullYear()));
        this.sortPersonalStartDate();
        this.sortWorkAbroadStartDate();
    }

    /**
     * Sort the personal vacation data.
     * Convert date as a string into an ISO string to sort correctly
     */
    sortPersonalStartDate() {
        for (const element of this.dataSourceVacation.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     * Sort the work abroad data.
     * Convert date as a string into an ISO string to sort correctly
     */
    sortWorkAbroadStartDate() {
        for (const element of this.dataSourceWork.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     * Calculates the card value for vacation
     * */
    public calculateCardValues(year: string) {
        let pendingVacation = 0;
        let totalVacation = 0;
        let remainingVacation = 0;
        let carryover = 0;
        this.selectedData[0].allVacationRequest.forEach((value: any) => {
            if (year == value.year && value.gmin == this.selectedData[1].gmin) {
                totalVacation = value.vacationAllowance;
                remainingVacation = value.vacationAllowanceRemaining;
                carryover = value.vacationAllowanceCarryover;
            }
        });
        this.dataSourceVacation.data.forEach((data) => {
            if (year === data.year && data.requestStatus == 'PENDING') {
                pendingVacation += data.numberOfAnnualLeaveDays;
            }
        });
        this.getDisplayValueVacation.set('total', String(totalVacation));
        this.getDisplayValueVacation.set('remaining', String(remainingVacation));
        this.getDisplayValueVacation.set('pending', String(pendingVacation));
        this.getDisplayValueVacation.set('carryover', String(carryover));
        this.calculateWorkCardValues(year);
    }

    /**
     * Calculates the card value for Work Abroad
     * */
    public calculateWorkCardValues(year: string) {
        let pendingWork = 0;
        let totalWork = 40;
        let remainingWork = 40;
        let negativeCarryover = 0;
        this.selectedData[0].allWorkRequest.forEach((value: any) => {
            if (value.gmin == this.selectedData[1].gmin) {
                totalWork = value.workAllowanceTotal;
                remainingWork = value.workAbroadAllowanceRemaining;
                negativeCarryover = value.workAbroadNegativeCarryOver;
            }
        });
        this.dataSourceWork.data.forEach((data) => {
            if (year === data.year && data.requestStatus === 'PENDING') {
                pendingWork += data.numberOfWorkAbroadDays;
            }
        });

        this.getDisplayValueWork.set('total', String(totalWork));
        this.getDisplayValueWork.set('remaining', String(remainingWork));
        this.getDisplayValueWork.set('pending', String(pendingWork));
        this.getDisplayValueWork.set('negativeCarryover', String(negativeCarryover));
    }

    /**
     * Return string value for the provided boolean
     * */
    public halfDayStatus(bool: boolean): string {
        return this.managerService.halfDayStatus(bool);
    }
}
